import type { Theme } from '../../types/theme';

export const cohereTheme: Theme = {
  id: 'cohere',
  name: 'Cohere',
  description: 'Dark enterprise AI platform with bold red accents',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/cohere/DESIGN.md',
  visualKeywords: ['dark', 'red accent', 'data-rich', 'enterprise AI', 'bold'],
  colors: {
    background: '#0f172a',
    surface: '#1e293b',
    surfaceElevated: '#283345',
    textPrimary: '#f8fafc',
    textSecondary: '#94a3b8',
    textMuted: '#94a3b8',
    border: '#334155',
    borderSubtle: '#3d4b5f',
    primary: '#e63946',
    primaryHover: '#f54855',
    primaryActive: '#c81b28',
    accent: '#e63946',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'high',
    tone: 'enterprise',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
